/**
 *
 * @param {String} content
 */
export default function setupHTML(content) {
  return { __html: content };
}
